import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../../hooks/usePageTitle';
import { getStoredShop } from '../../utils/tianlanStore';
import '../../styles.css';
import '../../tianlan-styles.css';

function TianlanExchangeHome() {
  // 設置頁面標題
  usePageTitle('管理後台', '天藍小舖', '訂單售後服務平台');
  const currentShop = getStoredShop();
  const customerUrl = `${window.location.origin}/tianlan/customer`;
  
  return (
    <div className="tianlan-exchange-home-new">
      <div className="page-header">
        <div className="header-content">
          <button onClick={() => window.history.back()} className="back-btn">
            ←
          </button>
          <div className="title-section">
            <h1>訂單售後服務平台</h1>
            <p>目前商店：{currentShop.storeName}（{currentShop.shopUserId}）</p>
          </div>
        </div>
      </div>

      <div className="main-content tl-admin-workspace">
        <section className="tl-admin-hero">
          <div>
            <div className="tl-admin-kicker">Skyblue after-sales desk</div>
            <h2>直播訂單售後後台</h2>
            <p>集中管理直播商品、缺貨換貨、客人資料回填與後續售後處理。</p>
          </div>
          <div className="tl-admin-meta">
            <span className="tl-pill">目前商店 <strong>{currentShop.shopUserId}</strong></span>
            <span className="tl-pill">客戶頁 <strong>跨店查詢</strong></span>
          </div>
        </section>

        <div className="function-grid">
          <Link to="/exchange/tianlan/products" className="function-card">
            <div className="card-header">
              <h2>商品規則管理</h2>
            </div>
            <p>設定商品可建立的換貨任務、可換商品與售後表單題目。</p>
          </Link>

          <Link to="/exchange/tianlan/orders" className="function-card">
            <div className="card-header">
              <h2>訂單售後服務後台</h2>
            </div>
            <p>同一頁查詢訂單、建立單一任務、設定期限並追蹤客人處理進度。</p>
          </Link>

          <Link to="/exchange/tianlan/stores" className="function-card">
            <div className="card-header">
              <h2>直播商店</h2>
            </div>
            <p>管理多店憑證、登入狀態與目前作業商店。</p>
          </Link>

          <Link to="/exchange/tianlan/settings" className="function-card">
            <div className="card-header">
              <h2>系統設定與前台樣式</h2>
            </div>
            <p>設定前台公告、iPad 子母畫面底色、按鈕顏色、維護模式與自動或人工換貨流程。</p>
          </Link>
        </div>

        <div className="info-section">
          <div className="customer-access">
            <div className="access-header">
              <h3>客戶查詢頁面</h3>
            </div>
            <div className="url-container">
              <div className="url-display-new">
                <code>{customerUrl}</code>
              </div>
              <button 
                onClick={(e) => {
                  navigator.clipboard.writeText(customerUrl);
                  const btn = e.target;
                  const originalText = btn.textContent;
                  btn.textContent = '已複製';
                  setTimeout(() => {
                    btn.textContent = originalText;
                  }, 2000);
                }}
                className="copy-btn"
              >
                複製
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default TianlanExchangeHome;
